import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const HowItWorks = () => {
  const navigate = useNavigate();
  
  const steps = [
    {
      number: '01',
      title: 'Choose Your Standee',
      description: 'Select Google or TripAdvisor review standee. Customize with your business details and branding.',
      bgColor: 'bg-blue-100',
      image: 'https://customer-assets.emergentagent.com/job_e20edfe9-c71c-4e95-b173-abda837e0358/artifacts/1rdqj17n_generated-image-1__2__copy-removebg-preview.png'
    },
    {
      number: '02',
      title: 'Place at Your Business',
      description: 'Display the standee at your counter, table, or entrance. Customers scan the QR code instantly.',
      bgColor: 'bg-purple-custom',
      image: 'https://customer-assets.emergentagent.com/job_e20edfe9-c71c-4e95-b173-abda837e0358/artifacts/55pctf4d_generated-image-1__2_-removebg-preview.png'
    },
    {
      number: '03',
      title: 'Collect Reviews',
      description: 'Watch your reviews grow as customers easily leave feedback. Track engagement and boost your ratings.',
      bgColor: 'bg-green-100',
      image: 'https://customer-assets.emergentagent.com/job_e20edfe9-c71c-4e95-b173-abda837e0358/artifacts/id6mavmc_Google-knowledge-panel-removebg-preview.png'
    }
  ];

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-5xl font-extrabold text-navy mb-4">
            Simple Steps to Get Started
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Three easy steps to create, customize, and start sharing your Smart Connection card
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {steps.map((step, index) => {
            return (
              <div 
                key={index}
                className={`${step.bgColor} rounded-[2.5rem] p-8 relative min-h-[450px] flex flex-col`}
              >
                {/* Step Number */}
                <div className="text-5xl font-extrabold text-navy mb-4">
                  {step.number}
                </div>
                
                {/* Image */}
                <div className="flex-1 flex items-center justify-center mb-4">
                  <img 
                    src={step.image} 
                    alt={step.title}
                    className="max-h-48 w-auto object-contain"
                  />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-navy mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  {step.description}
                </p>

                {/* Arrow for connection (except last item) */}
                {index < steps.length - 1 && (
                  <ArrowRight className="hidden md:block absolute -right-3 top-1/2 transform -translate-y-1/2 w-6 h-6 text-navy" />
                )}
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <Button 
            onClick={() => navigate('/shop')}
            className="bg-navy text-white hover:bg-navy/90 rounded-full px-8 py-6 text-lg font-semibold"
          >
            Get My Standee
          </Button>
        </div>
      </div>
    </section>
  );
};
